module.exports = __webpack_public_path__ + "static/media/6.418da8b5.jpg";